export const NEARBY_VEHICLE_RADIUS_M = 50

const EARTH_RADIUS_M = 6371000

export function haversineDistanceMeters (lat1, lng1, lat2, lng2) {
  const toRad = (deg) => (deg * Math.PI) / 180
  const dLat = toRad(lat2 - lat1)
  const dLng = toRad(lng2 - lng1)
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2
  return 2 * EARTH_RADIUS_M * Math.asin(Math.sqrt(a))
}

export function isValidCoord (lng, lat) {
  return Number.isFinite(Number(lng)) && Number.isFinite(Number(lat))
}

export function getNearbyVehicles (points, anchor, radiusMeters = NEARBY_VEHICLE_RADIUS_M) {
  if (!anchor || !isValidCoord(anchor.lng, anchor.lat)) return []
  const anchorLat = Number(anchor.lat)
  const anchorLng = Number(anchor.lng)
  return (points || []).filter((item) => {
    if (!isValidCoord(item.lng, item.lat)) return false
    const distance = haversineDistanceMeters(
      anchorLat,
      anchorLng,
      Number(item.lat),
      Number(item.lng),
    )
    return distance <= radiusMeters
  })
}

export function sortNearbyVehicles (vehicles, anchor) {
  const anchorLat = Number(anchor.lat)
  const anchorLng = Number(anchor.lng)
  return [...vehicles].sort((a, b) => {
    const distA = haversineDistanceMeters(anchorLat, anchorLng, Number(a.lat), Number(a.lng))
    const distB = haversineDistanceMeters(anchorLat, anchorLng, Number(b.lat), Number(b.lng))
    if (distA !== distB) return distA - distB
    return String(a.ebikeId || '').localeCompare(String(b.ebikeId || ''))
  })
}

export function buildNearbyVehicleGroup (points, anchor, radiusMeters = NEARBY_VEHICLE_RADIUS_M) {
  return sortNearbyVehicles(getNearbyVehicles(points, anchor, radiusMeters), anchor)
}
